(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-portal-2050"] && !Shopify.designMode) return;
  try {
    
if (!window.NazthirPortalMotion) {
  window.NazthirPortalMotion = true;
  const portalFor = (node) => node instanceof Element ? node.closest('[data-nz-portal]') : null;
  const prefersLessMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('pointermove', (event) => {
    const portal = portalFor(event.target);
    if (!portal || prefersLessMotion || event.pointerType === 'touch') return;
    const bounds = portal.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;
    const x = Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width));
    const y = Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height));
    portal.style.setProperty('--nz-x', (x * 100) + '%');
    portal.style.setProperty('--nz-y', (y * 100) + '%');
    const artifact = portal.querySelector('[data-nz-artifact]');
    if (!artifact) return;
    artifact.style.setProperty('--nz-tilt-x', ((.5 - y) * 4) + 'deg');
    artifact.style.setProperty('--nz-tilt-y', ((x - .5) * 5) + 'deg');
    artifact.style.setProperty('--nz-shift-x', ((.5 - x) * 10) + 'px');
    artifact.style.setProperty('--nz-shift-y', ((.5 - y) * 10) + 'px');
  }, { passive: true });
  document.addEventListener('pointerout', (event) => {
    const from = portalFor(event.target);
    const to = portalFor(event.relatedTarget);
    if (!from || from === to) return;
    from.style.setProperty('--nz-x', '50%');
    from.style.setProperty('--nz-y', '50%');
    const artifact = from.querySelector('[data-nz-artifact]');
    if (!artifact) return;
    artifact.style.setProperty('--nz-tilt-x', '0deg');
    artifact.style.setProperty('--nz-tilt-y', '0deg');
    artifact.style.setProperty('--nz-shift-x', '0px');
    artifact.style.setProperty('--nz-shift-y', '0px');
  });
}

  } catch(e) { console.error(e); }
})();
})();
